Object.defineProperty(exports, '__esModule', { value: true });

var isClient = function () { return typeof window !== 'undefined'; };

exports.isClient = isClient;
